const sliderWrapper = document.querySelector(".testimonials__slider");

new Swiper(sliderWrapper, {
    slidesPerView: 1,
    spaceBetween: 46,
    centeredSlides: false,
    autoplay: {
        delay: 8000,
        disableOnInteraction: false,
    },
    loop: true,
    speed: 500,
    pagination: {
        el: '.testimonials__pagination',
        clickable: true
    },
});
